import { getConfig } from "@/config";

export interface TAuth0Config {
    domain: string;
    clientId: string;
    audience: string;
    redirectUri: string;
}

export function getAuth0Config(): TAuth0Config {
    return {
        domain: getConfig("VITE_AUTH0_DOMAIN"),
        clientId: getConfig("VITE_AUTH0_CLIENT_ID"),
        audience: getConfig("VITE_AUTH0_AUDIENCE"),
        redirectUri: `${window.location.origin}/login/callback`,
    };
}
